import errorModal from '@/helpers/errorModal'
import { translate } from 'rhg-vue-common'

export const maxLengthStayErrorModal = () => {
  const { createErrorModal } = errorModal()
  const phoneNumber = document.querySelector('#customer-care-phone')?.textContent?.trim()
  const msgError = {
    title: translate('sbrMaximumNightsLength'),
    subtitle: `${translate('sbrPleaseCallFollowingNumber')} ${phoneNumber}`
  }
  const button = {
    show: true,
    url: '',
    label: translate('errBtnClose')
  }
  createErrorModal(msgError, button)
}
